import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { createTheme } from '@fluentui/styles';
import animations from './animations';
import * as siteVariables from './siteVariables';
import * as componentVariables from './componentVariables';
import * as componentStyles from './componentStyles';
import fontFaces from './fontFaces';
import staticStyles from './staticStyles';
import { default as svgIconsAndStyles } from './components/Icon/svg';

var declareSvg = function declareSvg(svgIcon) {
  return {
    isSvg: true,
    icon: svgIcon
  };
};

export var getIcon = function getIcon(iconAndMaybeStyles) {
  return iconAndMaybeStyles.styles ? iconAndMaybeStyles.icon : iconAndMaybeStyles;
};
var themeIcons = Object.keys(svgIconsAndStyles).reduce(function (accIcons, iconName) {
  var iconAndMaybeStyles = svgIconsAndStyles[iconName];
  var icon = getIcon(iconAndMaybeStyles);
  return Object.assign({}, accIcons, {}, _defineProperty({}, iconName, declareSvg(icon)));
}, {});
var icons = Object.assign({}, themeIcons, {
  'icon-checkmark': themeIcons['accept'],
  'icon-circle': themeIcons['icon-circle'],
  'icon-close': themeIcons['close'],
  'icon-arrow-up': themeIcons['triangle-up'],
  'icon-arrow-down': themeIcons['triangle-down'],
  'icon-arrow-end': themeIcons['triangle-right'],
  'icon-menu-arrow-down': themeIcons['chevron-down-medium'],
  'icon-menu-arrow-end': themeIcons['chevron-right-medium'],
  'icon-pause': themeIcons['pause'],
  'icon-play': themeIcons['play']
});
var teamsTheme = createTheme({
  siteVariables: siteVariables,
  componentVariables: componentVariables,
  componentStyles: componentStyles,
  fontFaces: fontFaces,
  staticStyles: staticStyles,
  icons: icons,
  animations: animations
}, 'teams');
export default teamsTheme;